import { PolymerElement, html } from '@polymer/polymer/polymer-element.js';
import './style/com-price-style.js';
import '@polymer/polymer/lib/elements/dom-if.js';

function toLocaleStringSupportsLocales() {
  var number = 0;
  try {
    number.toLocaleString("i");
  } catch (e) {
    return e.name === "RangeError";
  }
  return false;
}

if (!toLocaleStringSupportsLocales()) {
  var replaceSeparators = function(sNum, separators) {
      var sNumParts = sNum.split('.');
      if (separators && separators.thousands) {
          sNumParts[0] = sNumParts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + separators.thousands);
      }
      sNum = sNumParts.join(separators.decimal);

      return sNum;
  };

  var renderFormat = function(template, props) {
    for (var prop in props) {
      template = template.replace("{{" + prop + "}}", props[prop]);
    }

    return template;
  };

  var mapMatch = function(map, locale) {
    var match = locale;
    match = match.toLowerCase();
    var language = match && match.match(/^\w+/);

    if (!map.hasOwnProperty(match)) {
      if (map.hasOwnProperty(language)) {
        match = language;
      } else {
        match = "en";
      }
    }

    return map[match];
  };

  var dotThousCommaDec = function(sNum) {
    var separators = {
      decimal: ',',
      thousands: '.'
    };

    return replaceSeparators(sNum, separators);
  };

  var commaThousDotDec = function(sNum) {
    var separators = {
      decimal: '.',
      thousands: ','
    };

    return replaceSeparators(sNum, separators);
  };

  var spaceThousCommaDec = function(sNum) {
    var seperators = {
      decimal: ',',
      thousands: '\u00A0'
    };

    return replaceSeparators(sNum, seperators);
  };

  var apostrophThousDotDec = function(sNum) {
    var seperators = {
      decimal: '.',
      thousands: '\u0027'
    };

    return replaceSeparators(sNum, seperators);
  };

  var transformForLocale = {
    "en": commaThousDotDec,
    "it": dotThousCommaDec,
    "fr": spaceThousCommaDec,
    "de": dotThousCommaDec,
    "de-de": dotThousCommaDec,
    "de-at": dotThousCommaDec,
    "de-ch": apostrophThousDotDec,
    "de-li": apostrophThousDotDec,
    "de-be": dotThousCommaDec,
    "ro": dotThousCommaDec,
    "ro-ro": dotThousCommaDec,
    "hu": spaceThousCommaDec,
    "hu-hu": spaceThousCommaDec,
    "da-dk": dotThousCommaDec,
    "nb-no": spaceThousCommaDec,
    // LACD
    "es-ar": dotThousCommaDec,
    "es-cl": dotThousCommaDec,
    "es-co": dotThousCommaDec,
    "es-pe": dotThousCommaDec,
    "pt-br": dotThousCommaDec
};

var currencyFormatMap = {
    "en": "pre",
    "it": "post",
    "fr": "post",
    "de": "post",
    "de-de": "post",
    "de-at": "prespace",
    "de-ch": "prespace",
    "de-li": "post",
    "de-be": "post",
    "ro": "post",
    "ro-ro": "post",
    "hu": "post",
    "hu-hu": "post",
    "da-dk": "post",
    "nb-no": "post"
};

var currencySymbols = {
    "afn": "؋",
    "ars": "$",
    "awg": "ƒ",
    "aud": "$",
    "azn": "₼",
    "bsd": "$",
    "bbd": "$",
    "byr": "p.",
    "bzd": "BZ$",
    "bmd": "$",
    "bob": "Bs.",
    "bam": "KM",
    "bwp": "P",
    "bgn": "лв",
    "brl": "R$",
    "bnd": "$",
    "khr": "៛",
    "cad": "$",
    "kyd": "$",
    "clp": "$",
    "cny": "¥",
    "cop": "$",
    "crc": "₡",
    "hrk": "kn",
    "cup": "₱",
    "czk": "Kč",
    "dkk": "kr",
    "dop": "RD$",
    "xcd": "$",
    "egp": "£",
    "svc": "$",
    "eek": "kr",
    "eur": "€",
    "fkp": "£",
    "fjd": "$",
    "ghc": "¢",
    "gip": "£",
    "gtq": "Q",
    "ggp": "£",
    "gyd": "$",
    "hnl": "L",
    "hkd": "$",
    "huf": "Ft",
    "isk": "kr",
    "inr": "₹",
    "idr": "Rp",
    "irr": "﷼",
    "imp": "£",
    "ils": "₪",
    "jmd": "J$",
    "jpy": "¥",
    "jep": "£",
    "kes": "KSh",
    "kzt": "лв",
    "kpw": "₩",
    "krw": "₩",
    "kgs": "лв",
    "lak": "₭",
    "lvl": "Ls",
    "lbp": "£",
    "lrd": "$",
    "ltl": "Lt",
    "mkd": "ден",
    "myr": "RM",
    "mur": "₨",
    "mxn": "$",
    "mnt": "₮",
    "mzn": "MT",
    "nad": "$",
    "npr": "₨",
    "ang": "ƒ",
    "nzd": "$",
    "nio": "C$",
    "ngn": "₦",
    "nok": "kr",
    "omr": "﷼",
    "pkr": "₨",
    "pab": "B/.",
    "pyg": "Gs",
    "pen": "S/.",
    "php": "₱",
    "pln": "zł",
    "qar": "﷼",
    "ron": "lei",
    "rub": "₽",
    "shp": "£",
    "sar": "﷼",
    "rsd": "Дин.",
    "scr": "₨",
    "sgd": "$",
    "sbd": "$",
    "sos": "S",
    "zar": "R",
    "lkr": "₨",
    "sek": "kr",
    "chf": "CHF",
    "srd": "$",
    "syp": "£",
    "tzs": "TSh",
    "twd": "NT$",
    "thb": "฿",
    "ttd": "TT$",
    "try": "",
    "trl": "₤",
    "tvd": "$",
    "ugx": "USh",
    "uah": "₴",
    "gbp": "£",
    "usd": "$",
    "uyu": "$U",
    "uzs": "лв",
    "vef": "Bs",
    "vnd": "₫",
    "yer": "﷼",
    "zwd": "Z$"
  };

  var currencyFormats = {
    pre: "{{code}}{{num}}",
    post: "{{num}} {{code}}",
    prespace: "{{code}} {{num}}"
  };

  Number.prototype.toLocaleString = function(locale, options) {
    if (locale && locale.length < 2)
      throw new RangeError("Invalid language tag: " + locale);

    var sNum;

    if (options && options.minimumFractionDigits) {
      sNum = this.toFixed(options.minimumFractionDigits);
    } else {
      sNum = this.toString();
    }

    sNum = mapMatch(transformForLocale, locale)(sNum, options);

    if(options && options.currency && options.style === "currency") {
      var format = currencyFormats[mapMatch(currencyFormatMap, locale)];
      if(options.currencyDisplay === "code") {
        sNum = renderFormat(format, {
          num: sNum,
          code: options.currency.toUpperCase()
        });
      } else {
        sNum = renderFormat(format, {
          num: sNum,
          code: currencySymbols[options.currency.toLowerCase()]
        });
      }
    }

    return sNum;
  };
}

/**
 * `com-price`
 *
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class COMPrice extends PolymerElement {
  static get template() {
    return html`
    <style include="com-theme"></style>
    <style include="com-price-style"></style>

    <template is="dom-if" if="[[_isIOSDevice()]]">
      <span class="screen-reader-text">[[_ariaLabel(value, currency, hideDecimals)]]</span>
    </template>
    <span aria-hidden="[[_isIOSDevice()]]" id="symbol">[[symbol]]</span>
    <span aria-hidden="[[_isIOSDevice()]]" id="price">[[amount]]</span>
    <span aria-hidden="true" id="decimalAndCurrencyWrapper" hidden\$="[[_hideDecimalAndCurrencyWrapper(presentation, hideDecimals, hideCurrency)]]" class\$="[[_classDecimalAndCurrencyWrapper(hideDecimals)]]">
      <span id="decimalsWithinStack" hidden\$="[[_hideDecimalsWithinStack(presentation, hideDecimals)]]">[[decimals]]</span>
      <span id="currency" hidden\$="[[hideCurrency]]">[[currency]]</span>
    </span>
`;
  }

  static get is() {return 'com-price';}

  static get properties() {
    return {

      /**
       * @desc `value` is the price value.
       * @type String
       */
      value: {
        type: String,
        value: 0
      },

      /**
       * @desc plain text value matching visual presentation.
       * @type String
       */
      text: {
        type: String,
        computed: '_text(value, currency, locale, hideDecimals, hideCurrency)'
      },

      /**
       * @desc plain text value matching a11y requirement to include currency.
       * @type String
       */
      textAria: {
        type: String,
        computed: '_text(value, currency, locale, hideDecimals, false)'
      },

      /**
       * @desc `presentation` describes the visual look of the price block.
       * Valid values are: `marketing`, `commerce` and `inline`.
       * @type String
       */
      presentation: {
        type: String,
        value: 'marketing',
        reflectToAttribute: true
      },

      /**
       * @desc `currency` accepts international currency codes.
       * @type String
       */
      currency: {
        type : String,
        value: 'USD'
      },

      /**
       * @desc Currency Symbol
       * @type String
       */
      symbol: {
        type: String,
        computed: '_symbol(currency)'
      },

      /**
       * @desc Whole amount value
       * Note: Also contains decimals for `commerce` and `inline` presentations
       * @type String
       */
      amount: {
        type: String,
        computed: '_amount(value, locale, presentation, hideDecimals)'
      },

      /**
       * @desc Decimals amount
       * @type String
       */
      decimals: {
        type: String,
        computed: '_decimals(value, digits)'
      },

      /**
       * @desc `hideCurrency` determins if currency code is displayed.
       * @type Boolean
       */
      hideCurrency: {
        type: Boolean,
        value: false
      },

      /**
       * @desc `hideDecimals` determins if decimal amount is displayed.
       * @type Boolean
       */
      hideDecimals: {
        type: Boolean,
        value: false
      },

      /**
       * @desc locale
       * @type String
       */
      locale: {
        type: String,
        value: 'en-us'
      },

      /**
       * @desc text value for screen reader (a11y requirement)
       * @type String
       */
      ariaLabel: {
        type: String,
        computed: '_ariaLabel(value, currency, hideDecimals)',
        reflectToAttribute: true
      }
    };
  }

  /**
   * @desc Currency Symbol
   * @param {String} Currency code
   * @return {String} Symbol
   */
  _symbol(currency) {
    return this._getAllSymbols()[currency];
  }

  /**
   * @desc Get price amount without decimal part.
   * Note: `commerce` and `inline` presentations include decimal here instead of decimal and currency wrapper.
   * TODO: locale support
   *
   * @param {String|Number} value
   * @param {String} presentation
   * @param {Boolean} hide decimals
   * @return {Number} price amount
   */
  _amount(value, locale, presentation, hideDecimals) {
    var digits = 2;

    if (typeof value === 'string') {
      value = value.replace('$',''); // remove $ (data coming from CMS)
    }

    value = parseFloat(value);

    if (hideDecimals) {
      value = Math.ceil(value);
      digits = 0;
    }

    if (presentation === 'marketing') {
      value = Math.floor(value);
      digits = 0;
    }

    if (!locale) return 0;

    let cleanedLocale = locale.replace('_', '-');
    return value.toLocaleString(cleanedLocale, {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
    });
  }

  /**
   * @desc Get decimals from price value
   * @param {String} price value
   * @param {Number} digits precision
   * @return {String} decimals
   */
  _decimals(value, digits) {
    digits = digits || 2;

    return parseFloat(value).toFixed(digits)
      .toString()
      .replace(/.*\./, '')
      .substring(0, digits);
  }

  /**
   * Accessibility Text
   * @param {String} price value
   * @param {String} currency
   * @param {Boolean} hide decimals
   * @return {String} accessibility text
   */
  _ariaLabel(value, currency, hideDecimals) {
    let digits = 2;

    if (typeof value === 'string') {
      value = value.replace('$',''); // remove $ (data coming from CMS)
    }

    value = (hideDecimals) ? Math.ceil(value) : parseFloat(Number(value).toFixed(digits));

    return value + ' ' + currency;
  }

  /**
   * @desc determine if hiding decimals within the decimals and currency stacked items
   * Note: only marketing presentation should ever show decimals here.
   * @param {String} presentation
   * @param {Boolean} hideDecimals
   * @return {Boolean}
   */
  _hideDecimalsWithinStack(presentation, hideDecimals) {
    if (presentation !== 'marketing') {
      return true;
    }

    return hideDecimals;
  }

  /**
   * Hide Decimal and Currency Wrapper
   * Note: Hides this wrapper
   * @param {String} presentation
   * @param {Boolean} hideDecimals
   * @param {Boolean} hideCurrency
   * @return {Boolean}
   */
  _hideDecimalAndCurrencyWrapper(presentation, hideDecimals, hideCurrency) {
    if (hideDecimals && hideCurrency) return true;
    if (presentation !== 'marketing' && hideCurrency) return true;
    return false;
  }

  /**
   * Decimal and Currency Wrapper CSS Class
   * Note: Just applies class so children can adjust
   * @param {Boolean} hideDecimals
   * @return {String} css class
   */
  _classDecimalAndCurrencyWrapper(hideDecimals) {
    return hideDecimals ? 'hide-decimals' : '';
  }

  /**
   * @desc compute the plain text value
   * @param {String} price value
   * @param {String} currency
   * @param {String} locale
   * @param {Boolean} hideDecimals
   * @param {Boolean} hideCurrency
   * @return {String} view value
   */
  _text(value, currency, locale, hideDecimals, hideCurrency) {
    let textValue = this._symbol(currency);
    // force inline presentation for computation so that both amount and decimals are given
    textValue += this._amount(value, locale, 'inline', hideDecimals);
    textValue += hideCurrency ? '' : ' ' + currency;
    return textValue;
  }

  /**
   * Detects IOS devices by user agent to add necessary accessability text
   * @return {Boolean}
   */
  _isIOSDevice() {
    const isIOS = /Mac|iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    return isIOS;
  }

  /**
   * @return {Object} price symbols
   */
  _getAllSymbols() {
    return {
      'ALL': '\u004c\u0065\u006b',
      'AFN': '\u060b',
      'ARS': '\u0024',
      'AWG': '\u0192',
      'AUD': '\u0024',
      'AZN': '\u043c\u0430\u043d',
      'BSD': '\u0024',
      'BBD': '\u0024',
      'BYR': '\u0070\u002e',
      'BZD': '\u0042\u005a\u0024',
      'BMD': '\u0024',
      'BOB': '\u0024\u0062',
      'BAM': '\u004b\u004d',
      'BWP': '\u0050',
      'BGN': '\u043b\u0432',
      'BRL': '\u0052\u0024',
      'BND': '\u0024',
      'KHR': '\u17db',
      'CAD': '\u0024',
      'KYD': '\u0024',
      'CLP': '\u0024',
      'CNY': '\u00a5',
      'COP': '\u0024',
      'CRC': '\u20a1',
      'HRK': '\u006b\u006e',
      'CUP': '\u20b1',
      'CZK': '\u004b\u010d',
      'DKK': '\u006b\u0072',
      'DOP': '\u0052\u0044\u0024',
      'XCD': '\u0024',
      'EGP': '\u00a3',
      'SVC': '\u0024',
      'EEK': '\u006b\u0072',
      'EUR': '\u20ac',
      'FKP': '\u00a3',
      'FJD': '\u0024',
      'GHC': '\u00a2',
      'GIP': '\u00a3',
      'GTQ': '\u0051',
      'GGP': '\u00a3',
      'GYD': '\u0024',
      'HNL': '\u004c',
      'HKD': '\u0024',
      'HUF': '\u0046\u0074',
      'ISK': '\u006b\u0072',
      'INR': '\u20b9',
      'IDR': '\u0052\u0070',
      'IRR': '\ufdfc',
      'IMP': '\u00a3',
      'ILS': '\u20aa',
      'JMD': '\u004a\u0024',
      'JPY': '\u00a5',
      'JEP': '\u00a3',
      'KZT': '\u043b\u0432',
      'KPW': '\u20a9',
      'KRW': '\u20a9',
      'KGS': '\u043b\u0432',
      'LAK': '\u20ad',
      'LVL': '\u004c\u0073',
      'LBP': '\u00a3',
      'LRD': '\u0024',
      'LTL': '\u004c\u0074',
      'MKD': '\u0434\u0435\u043d',
      'MYR': '\u0052\u004d',
      'MUR': '\u20a8',
      'MXN': '\u0024',
      'MNT': '\u20ae',
      'MZN': '\u004d\u0054',
      'NAD': '\u0024',
      'NPR': '\u20a8',
      'ANG': '\u0192',
      'NZD': '\u0024',
      'NIO': '\u0043\u0024',
      'NGN': '\u20a6',
      'NOK': '\u006b\u0072',
      'OMR': '\ufdfc',
      'PKR': '\u20a8',
      'PAB': '\u0042\u002f\u002e',
      'PYG': '\u0047\u0073',
      'PEN': '\u0053\u002f',
      'PHP': '\u20b1',
      'PLN': '\u007a\u0142',
      'QAR': '\ufdfc',
      'RON': '\u006c\u0065\u0069',
      'RUB': '\u0440\u0443\u0431',
      'SHP': '\u00a3',
      'SAR': '\ufdfc',
      'RSD': '\u0414\u0438\u043d\u002e',
      'SCR': '\u20a8',
      'SGD': '\u0024',
      'SBD': '\u0024',
      'SOS': '\u0053',
      'ZAR': '\u0052',
      'LKR': '\u20a8',
      'SEK': '\u006b\u0072',
      'CHF': '\u0043\u0048\u0046',
      'SRD': '\u0024',
      'SYP': '\u00a3',
      'TWD': '\u004e\u0054\u0024',
      'THB': '\u0e3f',
      'TTD': '\u0054\u0054\u0024',
      'TRY': '\u20ba',
      'TRL': '\u20a4',
      'TVD': '\u0024',
      'UAH': '\u20b4',
      'GBP': '\u00a3',
      'USD': '\u0024',
      'UYU': '\u0024\u0055',
      'UZS': '\u043b\u0432',
      'VEF': '\u0042\u0073',
      'VND': '\u20ab',
      'YER': '\ufdfc',
      'ZWD': '\u005a\u0024'
    };
  }
}
window.customElements.define(COMPrice.is, COMPrice);
